import vtkGenericWidgetRepresentation from './GenericWidgetRepresentation';
import vtkRenderPass from './RenderPass';
import vtkViewNode from './ViewNode';
import vtkViewNodeFactory from './ViewNodeFactory';

export default {
  vtkGenericWidgetRepresentation,
  vtkRenderPass,
  vtkViewNode,
  vtkViewNodeFactory,
};
